/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = None 1 = VPNs 2 = Datacenters 4 = Proxies 8 = TorExitNodes 16 = Botnets 32 = VulnerabilityScanners 64 = WebScrapers 128 = SearchEngines 256 = SearchEngineCrawlers 512 = AiSearch 1024 = AiCrawlers 2048 = AiAgents 4096 = PagePreview 8192 = InternetTools
 */
export type AccessListCategory = 0 | 1 | 2 | 4 | 8 | 16 | 32 | 64 | 128 | 256 | 512 | 1024 | 2048 | 4096 | 8192;

export const AccessListCategory = {
  None: 0 as AccessListCategory,
  VPNs: 1 as AccessListCategory,
  Datacenters: 2 as AccessListCategory,
  Proxies: 4 as AccessListCategory,
  TorExitNodes: 8 as AccessListCategory,
  Botnets: 16 as AccessListCategory,
  VulnerabilityScanners: 32 as AccessListCategory,
  WebScrapers: 64 as AccessListCategory,
  SearchEngines: 128 as AccessListCategory,
  SearchEngineCrawlers: 256 as AccessListCategory,
  AiSearch: 512 as AccessListCategory,
  AiCrawlers: 1024 as AccessListCategory,
  AiAgents: 2048 as AccessListCategory,
  PagePreview: 4096 as AccessListCategory,
  InternetTools: 8192 as AccessListCategory,
};
